<template>
  <v-list-item :key="request.customer_request_id" @click="$emit('drill-down', request)">
    <v-list-item-content>
      <v-list-item-title v-if="request.is_valid" class="d-flex">
        <div>
          <strong>{{ request.name }}</strong>
          <v-icon 
            color="#F47C02" small class="ml-1 pb-1" 
            v-if="request.source_type == 'from_consumer'"
          >
            mdi-qrcode
          </v-icon>
        </div>
        <div class="ml-auto text-body-2 grey--text text--darken-1">{{ formatDate(request.request_time) }}</div>
      </v-list-item-title>

      <v-list-item-title v-else class="d-flex">
        <div class="grey--text text--darken-1"><strong>{{ request.name }}</strong> <em>(disqualified)</em></div>
        <div class="ml-auto text-body-2 grey--text text--darken-1">{{ formatDate(request.request_time) }}</div>
      </v-list-item-title>

      <v-list-item-subtitle class="d-flex grey--text text--darken-1">
        <div>
          {{ request.service }}
        </div>
        <div class="ml-auto">
          {{ request.claimed }} of {{ request.total }} claimed
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import formatters from '@/lib/formatters'

export default {
  name: 'LeadItem',

  props: {
    request: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...formatters,
  }
}

</script>